import './CookieList.scss'
import { groupBy, map, pipe, prop, toPairs } from 'ramda'
import Breadcrumb from '../../Breadcrumb'
import Head from './../../Head'
import Overlay from './../../Loader/Overlay'
import React from 'react'
import translate from '../../../utilities/translate'
import translations from './translations'
import Heading from '../../../widgets/Typography/Heading'

// trans :: String -> String -> String
const trans = translate(translations)

export default ({
  otData,
  locale,
}) =>
  <div data-is="cookie-list" className="page-content">
    <Head title={ trans(locale)('title') } />
    <div className="container container-page">
      <Breadcrumb crumbs={ [{ label: trans(locale)('title') }] } />
      <Heading level="1">{trans(locale)('title')}</Heading>
      {otData === null
        ? <Overlay />
        : <>
          <p>{otData.CookieListDescription}</p>

          {otData.Groups.map(group =>
            <CookieGroup
              key={ group.OptanonGroupId }
              group={ group }
              locale={ locale }
            />,
          )}
        </>
      }
    </div>
  </div>

// renderCookies :: [Cookie] -> React.Component
const renderCookies = cookies => cookies.map(({ description, Name }, index) =>
  <>
    { index > 0 ? <>&emsp;</> : null }
    <span key={ Name } className="is-cookie" title={ description }>
      {Name}
    </span>
  </>,
)

// CookieGroup :: Props ->
const CookieGroup = ({
  group,
  locale,
}) =>
  <section
    data-is="cookie-group"
    className={ group.Parent === '' ? 'parent-group' : 'sub-group' }
  >
    <h2>{group.GroupName}</h2>
    <p>{group.GroupDescription}</p>

    {/* only render cookie table when there is identified cookies */}
    {(group.FirstPartyCookies.length > 0 || group.Hosts.length.length > 0) &&
      <table className="table table-striped">
        <thead>
          <tr>
            <th>{trans(locale)('cookiesSubgroup')}</th>
            <th>{trans(locale)('cookies')}</th>
            <th>{trans(locale)('cookiesUsedBy')}</th>
          </tr>
        </thead>
        <tbody>
          {/* render 1st party cookies */}
          {pipe(
            groupBy(prop('Host')),
            toPairs,
            map(([ host, cookies ]) =>
              <tr key={ `${group.OptanonGroupId}-1st-host-${host}` }>
                <td>{host}</td>
                <td>{renderCookies(cookies)}</td>
                <td>{trans(locale)('firstParty')}</td>
              </tr>,
            ),
          )(group.FirstPartyCookies)}

          {/* render 3rd party cookies */}
          {group.Hosts.map(({ HostName, Description, Cookies }) =>
            <tr key={ `${group.OptanonGroupId}-3rd-host-${HostName}` }>
              <td title={ Description }>
                {HostName}
              </td>
              <td>{renderCookies(Cookies)}</td>
              <td>{trans(locale)('thirdParty')}</td>
            </tr>,
          )}
        </tbody>
      </table>
    }
  </section>
